import * as React from 'react'

import { Box, Icon, type MediumIcon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  icon: MediumIcon
  title: string
}

const Header = ({ icon, title }: Props) => {
  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      <Icon.Medium icon={icon} color="radicalRed1000" />
      <Text size="400" weight="medium" color="grey1000" inline>
        {title}
      </Text>
    </Box>
  )
}

export default observer(Header)
